import { render } from "./RatingInput.vue?vue&type=template&id=67f91e2c"
import script from "./RatingInput.vue?vue&type=script&lang=js"
export * from "./RatingInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__